import { Component, inject } from "@angular/core";
import { VdsButtonComponent } from "@dcc/vestas-design-system/angular/components/button";
import { UpdatePromptService } from "./update-prompt-button.service";
import { TranslocoPipe } from "@jsverse/transloco";

@Component({
    selector: "vo-update-prompt-button",
    templateUrl: "./update-prompt-button.component.html",
    host: {
        class: "contents"
    },
    imports: [VdsButtonComponent, TranslocoPipe],
    providers: [UpdatePromptService]
})
export class UpdatePromptButtonComponent {
    private updateService = inject(UpdatePromptService);

    public updateAvailable = this.updateService.updateAvailable;

    public async updateAndRestart(): Promise<void> {
        await this.updateService.updateAndRestart();
    }
}
